import { FormControlLabel } from '@mui/material';
import styled from 'styled-components';

export const Container = styled(FormControlLabel)`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
`;
